/*
 * Target the checkboxes on click for actual mailchimp form.
 */
(function ($) {
    $(document).ready(function () {
        $('.save-preference-text').hide();
        $('#save_preferences').hide();
        /* Disable all the children of hoover daily report */
        $("input.sub-hoover-re").attr("disabled", true);
       /* var interest_groups = {
            'b42c9394f4' : 'Hoover Weekend Review',
            'b4532d3730' : 'Hoover Monthly Briefings'
            'b11ebecf89' : 'Hoover Weekend Review',
            'f7849d50cc' :  'Hoover Monthly Briefings',
            '17883c86dc' : 'Monthly Briefing on the Economy',
            '9e85ca01f0' : 'Monthly Briefing on the Education',
            '43084d3ca7' : 'Monthly Briefing on National Security'
        }*/
        var obj_interest_groups = {
            'list-hoover-weekend-review' : 'b42c9394f4',
            'list-hoover-monthly-economy' : '17883c86dc',
            'list-hoover-monthly-education' : '9e85ca01f0',
            'list-hoover-monthly-security' : '43084d3ca7',
            'list-hoover-monthly-election' : '3225ceb986',
            'list-hoover-monthly-briefings' : 'b4532d3730'
        }
        var obj_in = {
            'b42c9394f4' : 'list-hoover-weekend-review',
            '17883c86dc' : 'list-hoover-monthly-economy',
            '9e85ca01f0' : 'list-hoover-monthly-education',
            '43084d3ca7' :  'list-hoover-monthly-security',
            '3225ceb986' : 'list-hoover-monthly-election',
            'b4532d3730' : 'list-hoover-monthly-briefings'
        }
        var obj = {
            'list-hoover-report': 'edit-mailchimp-lists-mailchimp-21b1edff3c-subscribe',
            'list-defining': 'edit-mailchimp-lists-mailchimp-31433b2ef9-subscribe',
            'list-caravan': 'edit-mailchimp-lists-mailchimp-d790910c21-subscribe',
            'list-hoover-digest': 'edit-mailchimp-lists-mailchimp-db86d9b656-subscribe',
            'list-california': 'edit-mailchimp-lists-mailchimp-7c523ba4de-subscribe',
            'list-event-notification': 'edit-mailchimp-lists-mailchimp-c0f9950213-subscribe',
            'list-strategika': 'edit-mailchimp-lists-mailchimp-ec368bf78b-subscribe',
            'list-monthly-newsletter': 'edit-mailchimp-lists-mailchimp-cf6b4ee2b2-subscribe',
            'list-tune-in': 'edit-mailchimp-lists-mailchimp-c52c8fa9e5-subscribe',
            'list-tower': 'edit-mailchimp-lists-mailchimp-9827b1d4e3-subscribe',
            'list-uncommon-knowledge': 'edit-mailchimp-lists-mailchimp-610ce6eca4-subscribe',
            'list-hoover-monthly-podblast': 'edit-mailchimp-lists-mailchimp-b1eb93251b-subscribe',
            'list-hoover-weekend-review': 'edit-mailchimp-lists-mailchimp-b4742ebbe4-subscribe',
            'list-hoover-monthly-economy': 'edit-mailchimp-lists-mailchimp-21b1edff3c-interest-groups-7093ab25e6-17883c86dc',
            'list-hoover-monthly-education': 'edit-mailchimp-lists-mailchimp-21b1edff3c-interest-groups-7093ab25e6-9e85ca01f0',
            'list-hoover-monthly-security': 'edit-mailchimp-lists-mailchimp-21b1edff3c-interest-groups-7093ab25e6-43084d3ca7',
            'list-hoover-monthly-election': 'edit-mailchimp-lists-mailchimp-21b1edff3c-interest-groups-7093ab25e6-3225ceb986',
            'list-hoover-monthly-briefings': 'edit-mailchimp-lists-mailchimp-21b1edff3c-interest-groups-458d5a14a0-f7849d50cc',
            'list-library-archive' : 'edit-mailchimp-lists-mailchimp-198e0bd348-subscribe--2'
        }
        $.each(obj, function (key, val) {
            $('#' + key).on("click", function () {
                //let selector = '[id^="' + val + '"]';
                //$(selector).trigger('click');
                $(`input[data-drupal-selector="${val}"]`).trigger('click');
            });
        });
        $('#mailchimp-mirror-email-field').on('change', function () {
            var val = $(this).val();
            $('#edit-mergevars-email').val(val);
        });
        $('#mailchimp-mirror-submit-button').click(function () {
            var val = $('#mailchimp-mirror-email-field').val();
            $('#edit-mergevars-email').val(val);
        });
        $('#list-hoover-report').click(function () {
            if (this.checked) {
                $("input.sub-hoover-re").removeAttr("disabled");
            } else {
                //$("input.sub-hoover-re").attr("disabled", true);
                $("input.sub-hoover-re").prop('checked', false);

                let monthlyChilds = [
                    'list-hoover-monthly-briefings',
                    'list-hoover-monthly-economy',
                    'list-hoover-monthly-education',
                    'list-hoover-monthly-security',
                    'list-hoover-monthly-election',
                    'list-hoover-weekend-review'
                ];
                monthlyChilds.forEach(function(val) {
                    // let selector = '[id^="' + obj[val] + '"]';
                    // $(selector).prop('checked', false);
                    $(`input[data-drupal-selector="${obj[val]}"]`).prop('checked', false);
                });
            }
        })
        $('#mailchimp-signup-subscribe-block-newsletter-subscription-form').on('submit', function () {
            $.each(obj, function (key, val) {
                $('#' + key).prop('checked', false);
            });

        });
    });
})(jQuery);
/*
 * Code ends here.
 */
/*
 * Code that executes when a existing user views the subscriptions.
 */
(function ($) {
    $(document).ready(function () {
        var obj_interest_groups = {
            'list-hoover-weekend-review' : 'b42c9394f4',
            'list-hoover-monthly-economy' : '17883c86dc',
            'list-hoover-monthly-education' : '9e85ca01f0',
            'list-hoover-monthly-security' : '43084d3ca7',
            'list-hoover-monthly-election' : '3225ceb986',
            'list-hoover-monthly-briefings' : 'b4532d3730'
        }
        var obj_in = {
            'b42c9394f4' : 'list-hoover-weekend-review',
            '17883c86dc' : 'list-hoover-monthly-economy',
            '9e85ca01f0' : 'list-hoover-monthly-education',
            '43084d3ca7' :  'list-hoover-monthly-security',
            '3225ceb986' : 'list-hoover-monthly-election',
            'b4532d3730' : 'list-hoover-monthly-briefings'
        }
        window.getmailchimpselection = function () {
            $('#mailchimp-email-button').attr("disabled", true);
            var email = $('#mailchimp-email').val();
            $.get("/api/mailchimp/" + email, function (data, status) {}).done(function(data, status) {
                if (status == 'success') {
                    console.log(data);
                    $('#save_preferences').show();
                    $('#mailchimp-mirror-email').hide();
                    $('#mailchimp-email-loader').html('');
                    $.each(data, function (index, value) {
                        console.log(value['status']);
                        if (value['status'] == 'subscribed') {
                            $('#' + index).prop('checked', true);
                            $('#' + index).closest('.col-four').addClass('show-border');
                            $('.sign-up-tab .we-error-message').hide();
                            $.each(value['interest_groups'], function (i, v) {
                                if (v == true) {
                                    $('#' + obj_in[i]).prop('checked', true);
                                    $('#' + obj_in[i]).closest('.three-col').addClass('show-border');
                                }
                            });
                        } else {
                            if (value['status'] == 'pending') {
                                $('#' + index).parent().parent().find('.remove').remove();
                                $('#' + index).parent().parent().append("<span class='remove'>PLEASE CHECK YOUR EMAIL TO CONFIRM YOUR SUBSCRIPTION.</span>");
                            }
                            $('.subscription-overlay').removeClass('overlay-active');
                            $('#mailchimp-email-button').attr("disabled", false);
                            /* Matchheight function. */
                            $('.newsletter-grid .grid-wrapper .three-col').matchHeight();
                            $('.newsletter-grid .cards-wrap .col-four').matchHeight();
                        }
                    });
                }
            });
        };
        /*
         * What happenns when a overlay form is submitted to retrive the list.
         */
        $('#get_list').submit(function (e) {
            $('#mailchimp-email-loader').append('<div class="ajax-progress ajax-progress-throbber"><div class="throbber">&nbsp;</div><div class="message">Please wait...</div></div>\n' +
                '        ');
            var email = $('#mailchimp-email').val();
            e.preventDefault();
            getmailchimpselection();

        });


        /*
         * Code ends here.
         */

        /*
         * All the code for save preferences goes here.
         * What happens when a user submit save preferences.
         */
        var checked_list = [];
        $(document).on('click', '#save_preferences, .myhoover-email-subscribe-save, .myhoover-update-email-subscribe', function () {
            // Check for email reference page on Myhoover
            var pageNodeId = $('.page-node-258624');
            var emailPrefNodeId = $('.page-node-258632');
            if (pageNodeId && pageNodeId.length) {
                var mailchimpBtnWrap = '.mailchimp-subscribe .btns-wrapper';
                var confirmCheckbox = $(mailchimpBtnWrap+' .checkbox-with-text input');    
                if (!confirmCheckbox.is(':checked')) {
                    $(mailchimpBtnWrap+' .error-message-wrap').show();
                    return false;
                }
            }

            $('.save-preference-text').show();
            $('.email-text').hide();
            $('#mailchimp-email').attr("disabled", true);
            $('#mailchimp-email-button').attr("disabled", true);
            /*
            * Adding code block again.
            */
            window.getmailchimpselection = function () {
                var email = $('#mailchimp-email').val();
                $.get("/api/mailchimp/" + email, function (data, status) {
                    if (status == 'success') {
                        console.log(data);
                        $('#save_preferences').show();
                        $('#mailchimp-mirror-email').hide();
                        $('#mailchimp-email-loader').html('');
                        $.each(data, function (index, value) {
                            console.log(value['status']);
                            if (value['status'] == 'subscribed') {
                                $('#' + index).closest('.col-four').addClass('show-border');
                                $('#' + index).prop('checked', true);
                                $.each(value['interest_groups'], function (i,v){
                                    if(v == true) {
                                        $('#' + obj_in[i]).closest('.three-col').addClass('show-border');
                                        $('#' + obj_in[i]).prop('checked', true);
                                    }
                                });
                            } else {
                                if (value['status'] == 'pending') {
                                    $('#' + index).parent().parent().find('.remove').remove();
                                    $('#' + index).parent().parent().append("<span class='remove'>PLEASE CHECK YOUR EMAIL TO CONFIRM YOUR SUBSCRIPTION.</span>");
                                }
                                $('.save-preference-text').hide();
                                $('.email-text').show();
                                $('#mailchimp-email').attr("disabled", false);
                                $('#mailchimp-email-button').attr("disabled", false);
                                $('.subscription-overlay').removeClass('overlay-active');
                                /* Matchheight function. */
                                $('.newsletter-grid .grid-wrapper .three-col').matchHeight();
                                $('.newsletter-grid .cards-wrap .col-four').matchHeight();
                            }
                        });

                        // email template [Myhoover]
                        var emailPreference = $('body.page-node-258624');
                        if(emailPreference && emailPreference.length) {
                            location.href = '/myhoover/follow-topics';
                            return false;
                        }

                        // email template [Myhoover Dashboard]
                        var accountEmailPreference = $('body.page-node-258632');
                        if(accountEmailPreference && accountEmailPreference.length) {
                            $(".mailchimp-subscribe .btns-row #newsletter-save-button").attr('disabled', false);
                        }
                    }
                });
            };
            var email = $('#mailchimp-email').val();
            if (pageNodeId && pageNodeId.length) {
                $(mailchimpBtnWrap+ " #newsletter-save-button").html("Subscribing ...").attr('disabled', true);
                $(mailchimpBtnWrap+' .error-message-wrap').hide();
            } else if(emailPrefNodeId && emailPrefNodeId.length) {
                $(".mailchimp-subscribe .btns-row #newsletter-save-button").attr('disabled', true);
                $('.my-feed-overlay').addClass('active');
            } else {
                $(".subscription-overlay").addClass("overlay-active");
            }
            $("#mailchimp-email").attr("disabled", true);
            $('#mailchimp-email-loader').append('<div class="ajax-progress ajax-progress-throbber"><div class="throbber">&nbsp;</div><div class="message">Please wait...</div></div>\n' +
                '        ');
            $('#mailchimp-email-button').attr("disabled", true);
            $('.hoover_list').each(function () {
                var interest = {};
                var list_state = $(this).is(":checked");
                if (list_state == true) {
                    var id = $(this).attr('id');
                    var value = $(this).attr('value');
                    if (id == 'list-hoover-report') {
                        $('.sub-hoover-re').each(function () {
                             var state = $(this).is(":checked");
                             var sub_id = $(this).attr("id");
                             interest[obj_interest_groups[sub_id]] = state;
                             
                             //interest[obj_interest_groups[sub_id]] = state;
                        });
                    }
                    checked_list[id] = value;
                    checked_list['interest'] = interest;
                }
            });
            console.log(checked_list);
            var myObject = Object.assign({}, checked_list);
            $.post("/api/set/mailchimp/list/" + email, {data: JSON.stringify(myObject)})
                .done(function (data) {
                    console.log(data);
                    if (data == true) {
                        getmailchimpselection();
                        $("#mailchimp-email").attr("disabled", false);
                        $('#mailchimp-email-button').attr("disabled", false);
                    }
                    //$.each(data, function (key, val) {
                    //  console.log(key+' '+val.id+val.value);
                    //});
                });
        })
    });
})(jQuery);